"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getIdTokenUserClaims = exports.getOktaTokens = exports.getMAPTokens = exports.getLocalStorage = exports.OKTA_TOKEN_STORAGE_KEY = exports.MAP_TOKEN_STORAGE_KEY = void 0;
const jwt_decode_1 = __importDefault(require("jwt-decode"));
exports.MAP_TOKEN_STORAGE_KEY = "ma-sso-tokens";
exports.OKTA_TOKEN_STORAGE_KEY = "okta-token-storage";
const getLocalStorage = () => {
    return window.localStorage;
};
exports.getLocalStorage = getLocalStorage;
const getMAPTokens = () => {
    const localStorage = (0, exports.getLocalStorage)();
    const tokensString = localStorage.getItem(exports.MAP_TOKEN_STORAGE_KEY);
    if (tokensString !== null) {
        return JSON.parse(tokensString);
    }
};
exports.getMAPTokens = getMAPTokens;
const getOktaTokens = () => {
    const localStorage = (0, exports.getLocalStorage)();
    const tokensString = localStorage.getItem(exports.OKTA_TOKEN_STORAGE_KEY);
    if (tokensString !== null) {
        return JSON.parse(tokensString);
    }
};
exports.getOktaTokens = getOktaTokens;
const getIdTokenUserClaims = () => {
    var _a;
    const tokens = (0, exports.getMAPTokens)();
    if (tokens === null || tokens === void 0 ? void 0 : tokens.idToken) {
        try {
            return (0, jwt_decode_1.default)(tokens.idToken);
        }
        catch (_b) { }
    }
    const oktaTokens = (0, exports.getOktaTokens)();
    return (_a = oktaTokens === null || oktaTokens === void 0 ? void 0 : oktaTokens.idToken) === null || _a === void 0 ? void 0 : _a.claims;
};
exports.getIdTokenUserClaims = getIdTokenUserClaims;
//# sourceMappingURL=token.js.map